import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const IDCardFilledIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path d="M20.28 18.54H3.72V5.38H20.28V18.54ZM9.08 11.52C9.82 11.52 10.4 10.92 10.4 10.2C10.4 9.48 9.82 8.88 9.08 8.88C8.36 8.88 7.78 9.48 7.78 10.2C7.78 10.92 8.36 11.52 9.08 11.52ZM12.52 9.4V11H16.66V9.4H12.52ZM11.22 14.58C11.22 13.42 10.26 12.46 9.1 12.46C7.94 12.46 6.96 13.42 6.96 14.58H11.22ZM12.52 12.98V14.58H16.66V12.98H12.52Z" />
    </SvgIcon>
  );
});
